<template>
	<div class="container">
		<div class="calendar">
			<div v-if="!loaded" class="loader_wrap">
				<span class="loader loader--large"></span>
			</div>
			<transition name="fade">
				<div v-if="loaded">
					<div v-for="event in events" :key="event.identifier">
						<Event :eventData="event" />
					</div>
				</div>
			</transition>
		</div>
	</div>
</template>

<script>
import Vue from 'vue';
import moment from 'moment';
import Event from '@/components/Event.vue';
// import '@/assets/scss/base.scss';
// import '@/assets/scss/grid.scss';
// import '@/assets/scss/mixins.scss';
// import '@/assets/scss/variables.scss';

Vue.prototype.moment = moment;

export default {
	name: 'calendar',
	components: {
		Event
	},
	data() {
		return {
			events: [],
			eventDays: [],
			week: {
				start: '',
				end: ''
			},
			loaded: false
		};
	},
	created: function() {
		const today = moment();
		const from_date = moment(today)
			.startOf('week')
			.add(1, 'day')
			.format('YYYY-MM-DD');
		const to_date = moment(today)
			.endOf('week')
			.add(1, 'day')
			.format('YYYY-MM-DD');

		this.week.start = from_date;
		this.week.end = to_date;

		// Alias the component instance as `vm`, so that we
		// can access it inside the promise function
		var vm = this;
		// Fetch our array of posts from an API
		fetch(
			'https://nlfchurch.churchsuite.co.uk/embed/calendar/json?date_start=' +
				this.week.start +
				'&date_end=' +
				this.week.end
		)
			.then(function(response) {
				return response.json();
			})
			.then(function(data) {
				vm.events = data;
				vm.checkDates(vm.events);
				// console.log(vm.events);
				vm.loaded = true;
			});
	},
	methods: {
		checkDates(events) {
			events.map((event, i) => {
				let eventDateOut = '';
				let eventDate = moment(event.datetime_start).format('ddd D');

				if (this.eventDays.includes(eventDate)) {
					eventDateOut = null;
				} else {
					eventDateOut = eventDate;
				}

				this.eventDays.push(eventDate);
				this.events[i].eventDay = eventDateOut;
			});
		}
	}
};
</script>

<style lang="scss" scoped>
.loader_wrap {
	position: absolute;
	top: 50%;
	right: 0;
	left: 0;
	transform: translateY(-50%);
}

.loader--large {
	width: 70px;
	height: 70px;
	border: 5px solid $blue;
	border-right-color: transparent;
	border-top-color: transparent;
	margin: 0 auto;
	opacity: 0.3;
}

.calendar {
	min-height: 166px;
	position: relative;
}
</style>
